<app-asset-listing-page
  [headerConfig]="headerConfig"
  [filterConfig]="filterConfig"
            [assets]="datasets"
            assetType="dataset"
            searchPlaceholder="Search for Datasets"
  filterSearchPlaceholder="Search for datasets"
  [searchQuery]="searchQuery"
            [currentPage]="currentPage"
            [totalPages]="totalPages"
            [viewMode]="viewMode"
            [itemsPerPage]="itemsPerPage"
            [showMobileFilterButton]="true"
  [isMobileFilterOpen]="isMobileFilterOpen"
  [isLoggedIn]="isLoggedIn"
        (filterChange)="onFilterChange($event)"
        (resetFilters)="onResetFilters()"
        (searchChange)="onSearchChange($event)"
  (pageChange)="onPageChange($event)"
  (viewModeChange)="onViewModeChange($event)"
  (itemsPerPageChange)="onItemsPerPageChange($event)"
  (openMobileFilter)="openMobileFilter()"
  (closeMobileFilter)="closeMobileFilter()"
  [sortOption]="sortOption"
  (sortChange)="onSortChange($event)"
  (bookmarksClick)="onBookmarksClick()"
></app-asset-listing-page>

<!-- Login Modal -->
<app-login-modal *ngIf="showLoginModal" (visibleChange)="showLoginModal = false"></app-login-modal>
